import IncomingInterceptor from '../IncomingInterceptor'

const api = new IncomingInterceptor()

export default {
  sendAlert(message: Object) {
    return api.post(message)
  },
}
